import { LinkedFirestoreOfflineDocument } from "@/core/modules/firestore/objects/LinkedFirestoreOfflineDocument";
import { Norm } from "./Norm";

import { StringField } from "@/core/fields";

export class LinkedNorm extends LinkedFirestoreOfflineDocument {
  public name: string | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromNorm(norm: Norm): LinkedNorm {
    const linkedNorm: LinkedNorm = new LinkedNorm();
    linkedNorm.id = norm.id;
    linkedNorm.name = norm.name;

    return linkedNorm;
  }

  public fromFirestore(data: Record<string, unknown>): LinkedNorm {
    super.fromFirestore(data);

    this.name = StringField.fromFirestore(data.name);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): LinkedNorm {
    super.fromOfflineCache(data);

    this.name = StringField.fromOfflineCache(data.name);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.name = StringField.toOfflineCache(this.name);

    return firestoreData;
  }
}
